export default __webpack_public_path__ + "static/media/logIn.f704c879.png";